/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    InputActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, InputActions.receiveInput))
);

export const updateInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, InputActions.updatedInput))
);

export const deleteInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, InputActions.deletedInput))
);

export const createInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, InputActions.createdInput))
);

export const validateInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_VALIDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, InputActions.validatedInput))
);

export const fetchInputLogEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_LOG && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, InputActions.receiveInputLog))
);

export const refreshInputEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_REFRESH && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, InputActions.refreshedInput))
);

export const fetchSocialInputCredsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.INPUT_LIST_SOCIAL_CREDS && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, InputActions.receiveSocialInputCreds))
);
